import { Button, H6, Tag } from "@blueprintjs/core";
import { useAdvancedStudyContext } from "contexts/AdvancedStudyContext/AdvancedStudyContext";
import useSelectedScopedBus from "contexts/SelectedScopedBusContext/useSelectedScopedBus";
import React from "react";
import { DEFAULT_MW_SIZE } from "types/advancedStudyType";
import "./AddMoreLoadsBar.scss";

interface AddMoreLoadsBarProps {
    busButton: React.ReactNode;
}

export const AddMoreLoadsBarWithSelectedBus = () => {
    const {
        bus: {
            niraBusId: selectedNiraBusId,
            busDisplayName: selectedBusDisplayName
        }
    } = useSelectedScopedBus();
    const { studyBuses, removeBus, addBus } = useAdvancedStudyContext();

    const isSelectedBusInStudyBuses = studyBuses.some(
        (bus) => bus.niraBusId === selectedNiraBusId
    );

    const busButton = isSelectedBusInStudyBuses ? (
        <Button
            intent="primary"
            onClick={() => removeBus(selectedNiraBusId)}
            ellipsizeText={true}
        >{`Remove ${selectedBusDisplayName}`}</Button>
    ) : (
        <Button
            intent="primary"
            onClick={() =>
                addBus({
                    niraBusId: selectedNiraBusId,
                    busDisplayName: selectedBusDisplayName,
                    studyMwSize: DEFAULT_MW_SIZE
                })
            }
            ellipsizeText={true}
        >{`Add ${selectedBusDisplayName}`}</Button>
    );

    return <AddMoreLoadsBar busButton={busButton} />;
};

export const AddMoreLoadsBarWithoutSelectedBus = () => {
    const busButton = <Button disabled>Select a bus to add</Button>;
    return <AddMoreLoadsBar busButton={busButton} />;
};

const AddMoreLoadsBar: React.FC<AddMoreLoadsBarProps> = (props) => {
    const { busButton } = props;
    const {
        isAddingMoreLoad,
        openNewStudyDialog,
        studyTitle,
        studyBuses,
        removeBus
    } = useAdvancedStudyContext();

    if (!isAddingMoreLoad) {
        return null;
    }

    return (
        <div className="AddMoreLoadsBar">
            <div className="AddMoreLoadsBar-content">
                <H6 className="AddMoreLoadsBar-title">{studyTitle}</H6>
                {studyBuses.length > 0 && (
                    <div className="AddMoreLoadsBar-buses">
                        {studyBuses.map((bus) => (
                            <Tag
                                className="AddMoreLoadsBar-bus-tag"
                                key={bus.niraBusId}
                                minimal
                                onRemove={() => removeBus(bus.niraBusId)}
                            >
                                {bus.busDisplayName}
                            </Tag>
                        ))}
                    </div>
                )}
                <div className="AddMoreLoadsBar-actions">
                    {busButton}
                    <Button onClick={openNewStudyDialog}>View Study</Button>
                </div>
            </div>
        </div>
    );
};
